import { FunctionalityStateModel } from './functionality.model';

export class UserStateModel {
  loading: boolean;
  email?: string;
  organization?: string;
  gravatar?: string;
  oldSurveyToolUrl?: string;
  hasChosenMunicipalityCode?: boolean;
  needsToChooseAccountType?: boolean;
  needsToProvideBillingInfo?: boolean;
  billingState?: any;
  unpaidLocked?: boolean;
  availableMunicipalities?: any[];
  availableCbdbeSources?: any[];
  availableEventCompassSources?: any[];
  statfeedAccess?: boolean;
  createdAt?: string;
  accountId?: number;
  showBillingInfoRequest?: boolean;
  selectedAccountType?: string;
  nordicBenchAccess?: boolean;
  cbdbeAccess?: boolean;
  eventCompassAccess?: boolean;
  matomoAccessToken?: string;
  canSwitchAccountType?: any;
  functionality?: FunctionalityStateModel;
}

export class LoadUser {
  static readonly type = '[User] LoadUser';
}
